"use client";
import React from "react";
import { ENTITY_TYPE } from "~/constants";
import { getTableHeadActions, TableCellActions } from "~/components/table/cells/TableCellActions.jsx";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";
import { TurnrTableCell, TurnrTableRow } from "~/components/table/TurnrTableSmart.jsx";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";
import EcomLogoIcon from "~/components/ecom/EcomLogoIcon.jsx";
import { COLORS } from "rylak-common/src/constants";
import ShopStatusIcon from "~/components/ShopStatusIcon.jsx";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import TestShopIcon from "~/components/TestShopIcon.jsx";
import { getTableHeadDateTime, TableCellDateTime } from "~/components/table/cells/TableCellDateTime.jsx";
import { EntityActionStatusChip } from "~/components/entityAction/EntityActionStatusChip.jsx";
import EntityActionFilterForm from "~/components/entityAction/EntityActionFilterForm.jsx";
import { TableCellId } from "~/components/table/cells/TableCellId.jsx";

const tableHeadData = {
    items: [
        {
            id: "type",
            label: "Platform",
            sortable: true,
            hide: "xs",
        },
        {
            id: "shop-icon",
            label: "",
            hide: "sm",
            sortable: false,
        },
        {
            id: "name",
            label: "Name",
            sortable: true,
            defaultSortedBy: true,
        },
        getTableHeadDateTime({ hide: "md" }),
        {
            id: "merchant",
            label: "Shop group",
            sortable: false,
            hide: "sm",
        },
        {
            id: "ingridSiteId",
            label: "Ingrid Site Id",
            sortable: false,
            hide: "lg",
            description: "ID used to connect different Ingrid products across domains",
        },
        {
            id: "workerStatus",
            label: "",
            sortable: false,
            hide: "lg",
        },
        {
            id: "shopStatus",
            label: "Status",
            sortable: false,
        },
        getTableHeadActions(),
    ],
};

function TableContent({ appProps, entitiesPaginatedService, reFetchEntitiesPaginated, ...rest }) {
    return entitiesPaginatedService?.data?.content?.map((shop) => {
        return (
            <TurnrTableRow key={shop?.id} {...rest}>
                <TurnrTableCell tight>
                    <EcomLogoIcon merchantBrand={shop} />
                </TurnrTableCell>
                <TurnrTableCell tight>
                    <CustomImageNew
                        style={{
                            display: !shop?.logoSrc && "none",
                        }}
                        src={shop?.logoSrc}
                        fixedHeight={30}
                        fixedWidth={30}
                    />
                </TurnrTableCell>
                <TurnrTableCell fullWidth={true}>
                    <div>{shop?.name}</div>
                    <div style={{ fontSize: "10px", color: COLORS.WEAK_TEXT }}>{shop?.displayName}</div>
                </TurnrTableCell>
                <TableCellDateTime dateTime={shop?.createdAt} />
                <TurnrTableCell>
                    <div>{shop?.merchant?.name}</div>
                </TurnrTableCell>
                <TableCellId fullWidth={true} id={shop?.ingridSiteId} />
                <TurnrTableCell fullWidth={true}>
                    <div style={{ marginLeft: "auto", textAlign: "right", width: "fit-content" }}>{shop?.workerInfo && <EntityActionStatusChip entity={shop} appProps={appProps} />}</div>
                </TurnrTableCell>
                <TurnrTableCell tight centerContent>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <TurnrTooltip content={shop?.isTestBrand && "Is a test shop"}>
                            <TestShopIcon shop={shop} />
                        </TurnrTooltip>
                        <TurnrTooltip content={shop?.shopStatus}>
                            <ShopStatusIcon shop={shop} />
                        </TurnrTooltip>
                    </div>
                </TurnrTableCell>
                <TableCellActions>
                    <EntityActionsDotsMenu hideIfEmpty={true} appProps={appProps} onSuccess={reFetchEntitiesPaginated} entity={shop} />
                </TableCellActions>
            </TurnrTableRow>
        );
    });
}

export default function AdminPageShopTab({ appProps }) {
    return (
        <EntityActionFilterForm appProps={appProps} entityType={ENTITY_TYPE.SHOP} tableHeadData={tableHeadData}>
            <TableContent appProps={appProps} />
        </EntityActionFilterForm>
    );
}
